import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin(({ $dayjs }) => {
  return {
    provide: {
      dateWrapper: $dayjs,
    },
  }
})
